import React, { useRef, useEffect } from 'react';
// import styled from 'styled-components';
import BaseModal from 'src/components/shared/modals/BaseModal';
import { FlexDirectionConfigs } from '@constants/config';
// import CollapseSideBarItem from '@components/sidebar/CollapseSideBarItem';
// import { MENU_LOGO_VIEW_HEIGHT, MOBILE_SIDEBAR_WIDTH_EXPAND } from '@constants/numbers';
import { IMAGE_DOMAINS } from '@constants/api';
import { getCurrentYYYYMMDDhhmmss } from '@utils/util';
import { SidebarWrap } from '@components/sidebar/styles';
import ExpandSideBarItem from '@components/sidebar/ExpandSideBarItem';
import PWAExpandSideBarItem from '@components/sidebar/PWAExpandSideBarItem';
import AfterLoginView from '@components/sidebar/AfterLoginView';
import { SWITCH_ROUTES } from '@constants/routes';
import { shouldSidebarAccountDisplay, shouldLogoDisplay, shouldDisplayInstallButtonsInSidebar, IS_NEW_AW, shouldDisplayLoginButton, shouldPromptPWAInstall } from '@constants/config';
import useMobileDetect from '@hooks/useMobileDetect';

const CURRENT_TIME = getCurrentYYYYMMDDhhmmss();
const SideBarModal = (props) => {
    const {
        menuItems,
        openSideBarModal,
        onToggleSideBarModal,
        setOpenLoginModal,
        navigate,
        location,
        isLogin,
        tCommon,
    } = props;
    const stopPropagation = (e) => {
        e.stopPropagation();
    };

    let jkeyRef = useRef();
    useEffect(() => {
        async function fetch() {
            const params = new URLSearchParams(location.search);
            jkeyRef.current = params.get('jkey');
        }
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const logoImgUrl = `${IMAGE_DOMAINS.LOGOS}/desktop-logo.png?gettime=${CURRENT_TIME}`;
    const isMobileDevice = useMobileDetect();
    
    return (
        <BaseModal
            show={openSideBarModal}
            justifyContent={FlexDirectionConfigs.FlexStart}
            alignItems={FlexDirectionConfigs.FlexStart}
            handleOutsideClick={onToggleSideBarModal}
        >
            <SidebarWrap
                isExpand={true}
                isLogin={isLogin}
                onClick={stopPropagation}
                isMobile={true}
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    height: '100%',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <div className="logo-wrap">
                {shouldLogoDisplay() && <img alt="logo" src={logoImgUrl} />}
                    {shouldDisplayLoginButton() && !jkeyRef.current && !isLogin && (
                        <button
                            className="login-btn"
                            onClick={(IS_NEW_AW) ? () => navigate(SWITCH_ROUTES.LOGIN) : () => setOpenLoginModal(true)}
                        >
                            {tCommon['common@login']}
                        </button>
                    )}
                    {shouldDisplayLoginButton() && jkeyRef.current && !isLogin && (
                        <button
                            className="login-btn"
                            onClick={() => {
                                navigate({
                                    pathname: SWITCH_ROUTES.REGISTER,
                                    search: `?jkey=${jkeyRef.current}`,
                                });
                            }}
                        >
                            {tCommon['common@register']}
                        </button>
                    )}

                    {isLogin && <AfterLoginView />}
                </div>
                <div className="sidebar-items" style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    flex: '1',
                    overflowY: 'auto',
                    overscrollBehavior: 'contain' /* Prevents scroll chaining */
                }}>
                {menuItems.map((m) => (
                    <ExpandSideBarItem
                        key={m.menuName}
                        active={m.path === location.pathname}
                        {...m}
                        menuName={`${m.menuNamePrefix ? `${m.menuNamePrefix} ` : ''}${tCommon[`sidebar@${m.menuName}`]}`}
                        navigate={navigate}
                        closeSidebarModal={onToggleSideBarModal}
                    />
                ))}
                {shouldDisplayInstallButtonsInSidebar() && shouldPromptPWAInstall() && !isLogin && isMobileDevice && (
                    <PWAExpandSideBarItem
                        key="pwa-install"
                        active={SWITCH_ROUTES.PWA_INSTALL === location.pathname}
                        path={SWITCH_ROUTES.PWA_INSTALL}
                        menuName={tCommon['sidebar@pwa-install'] || '輕安裝'}
                        icon="download_action_40x40"
                        navigate={navigate}
                        closeSidebarModal={onToggleSideBarModal}
                    />
                )}
                </div>
            </SidebarWrap>
        </BaseModal>
    );
};

export default React.memo(SideBarModal);
